import { axios } from './request'

export let orgTerms = {}

// #703 — a fragment of text that names the members together with an article or
// an adjective that agrees with the word: «O sócio respondeu», «Mostrar sócios
// antigos». An organisation whose word does not take those forms (Túnel's
// «Associade») supplies its own fragment as `phrase.<key>` in the terminology;
// every other organisation has no such key and gets `fallback`, which is the
// expression the template had before — so its text cannot change.
export function phrase(key, fallback) {
  const v = orgTerms['phrase.' + key]
  return v === undefined ? fallback : v
}

// Makes `phrase` available in every template as `$phrase`.
export const phrasePlugin = {
  install(app) {
    app.config.globalProperties.$phrase = phrase
  },
}

// How long to wait before asking again. Same cadence as the ServerStatus probe
// (components/ServerStatus/ServerStatus.vue): it is the same wait, seen from a
// page that has not managed to mount yet.
const RETRY_INTERVAL_MS = 3000

// The whole app is built out of these terms — the router derives its paths from
// them (`/cooperadores` vs `/socios`) and the API decides them from ORG_TYPE, so
// there is nothing sensible to mount without them and no default the frontend
// could invent. Before #379 the failure path logged the error and never settled
// the promise; since `Sentry.init` and `app.mount` both live inside
// `getTerms().then(...)` (main.js), one failed request left a blank page that
// only a manual reload could recover, with nothing reported — which is part of
// why the network failures on this route are barely visible in Sentry. Keep
// waiting, but keep asking: the app now mounts by itself once the network is
// back.
export const getTerms = () => {
  return new Promise((resolve) => {
    let reported = false
    const attempt = () => {
      axios
        .get('terminology')
        .then((res) => {
          orgTerms = res.data.data
          resolve()
        })
        .catch((err) => {
          // Only the first failure: while offline this retries every few
          // seconds, and a log line per attempt is noise that also fills the
          // Sentry breadcrumb trail of whatever is eventually reported.
          if (!reported) {
            reported = true
            console.error(err)
          }
          setTimeout(attempt, RETRY_INTERVAL_MS)
        })
    }
    attempt()
  })
}
